import type { CSSObject } from '@emotion/react'
import { Color, Spacing, Typography } from '@opallabs/gem'
import type { StyleProps } from './types'

export const container = ({ theme }: StyleProps): CSSObject => ({
  // @see https://workwithopal.atlassian.net/browse/CAKE-2538?focusedCommentId=129922
  color: theme === 'light' ? '#666a6e' : Color[theme].Text.Gray,
  display: 'flex',
  ...Typography.M500,
  fontSize: Typography.T300.fontSize,
  lineHeight: `${Spacing.XS * 6.5}px`,
})
